
import { mapGetters } from 'vuex'
import { getBaseUrl } from '~/config/api'
import ui from '~/ZenOne-StoryBook/mixins/ui'
import TextInput from '~/components/Registration/input/index.vue'

export default {
  name: 'RegistrationStepFive',
  components: {
    TextInput
  },
  mixins: [ui],
  props: {},
  data() {
    return {
      externalError: '',
      changeEmailModal: false,
      newEmail: '',
      validNewEmail: false
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    title() {
      return this.user.emailConfirmed ? 'Your email address is verified!' : 'Let\'s verify your email address'
    }
  },
  watch: {
    user: {
      handler(v) {
        this.$emit('validation', v.emailConfirmed)
      },
      immediate: true
    }
  },
  async created() {
    // in case the socket message has stuck
    await this.$store.dispatch('user/SetUserPracticeLocation')
  },
  methods: {
    async changeEmail() {
      try {
        this.showFSLoader()

        const res = await this.$axios.post(`${getBaseUrl()}/api/v2/auth/change-email`, { new_email: this.newEmail })

        const {
          AccessToken: accessToken,
          RefreshToken: refreshToken
        } = res.data.tokenData
        if (!accessToken) throw new Error('No accessToken')
        if (!refreshToken) throw new Error('No refreshToken')

        await this.$auth.setUserToken(accessToken, refreshToken)
        await this.$store.dispatch('user/SetUserPracticeLocation')

        this.changeEmailModal = false

        this.showAlert({type: 'success', content: `New Invite sent to ${this.newEmail}`})
      } catch (e) {
        console.error('onConfirm', e)

        this.externalError = e.response?.data?.error ?? 'Something went wrong'
        return false
      } finally {
        this.hideFSLoader()
      }
    },
    nextBtnClickHandler() {
      return true
    }
  }
}
